<template>
  <v-container fluid fill-height class="justify-space-around webcamcontainer">
    <!-- Hospital id 2 === UZ Brussel -->
    <iframe
      v-if="true"
      src="https://eu.nicview.net/login.aspx"
      sandbox="allow-forms allow-same-origin allow-scripts allow-popups"
      id="webcam-frame"
      frameborder="0"
      name="nicview-frame"
    >
      <!-- Fallback -->
      <a href="https://eu.nicview.net/login.aspx">Naar NicView</a>
    </iframe>
    <div v-else class="display-message-container">
      <div class="display-message">
        <!-- <img :src="require('@/assets/images/duck-blue.svg')" alt="Duck icon" /> -->
        <p color="primary">
          Ik ben even weg,
          <br />want ik krijg een heerlijk badje <br />(Webcam currently
          offline)
        </p>
      </div>
    </div>
  </v-container>
</template>

<script>
import i18n from "@/services/i18n";

export default {
  i18n: i18n,
  name: "neoparent-webcam",
  props: [],
  components: {},
  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>

<style scoped lang="scss">
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
}

.webcamcontainer {
  height: calc(100% - 60px);
}

#webcam-frame {
  height: 90%;
  width: 90%;
}
</style>
